import { createRouter, createWebHashHistory } from "vue-router";
import MenuService from "../service/MenuService";

const routes = [
  {
    path: "/ReporteExportacion",
    name: "ReporteExportacion",
    component: () => import("../pages/ReporteExportacion.vue"),
  },
  {
    path: "/ControlRutasMeli",
    name: "ControlRutasMeli",
    component: () => import("../pages/ControlRutasMeli.vue"),
  },
  {
    path: "/ControlProveedorPowerDriver",
    name: "ControlProveedorPowerDriver",
    component: () => import("../pages/ControlProveedorPowerDriver.vue"),
  },
  {
    path: "/ControlRutasOtros",
    name: "ControlRutasOtros",
    component: () => import("../pages/ControlRutasOtros.vue"),
  },
  {
    path: "/ControlProceso",
    name: "ControlProceso",
    component: () => import("../pages/ControlProceso.vue"),
  },
  {
    path: "/ControlAsistencia",
    name: "ControlAsistencia",
    component: () => import("../pages/ControlAsistencia.vue"),
  },
  {
    path: "/ControlAltaEmpleados",
    name: "ControlAltaEmpleados",
    component: () => import("../pages/ControlAltaEmpleados.vue"),
  },
  {
    path: "/ControlAsignaciones",
    name: "ControlAsignaciones",
    component: () => import("../pages/ControlAsignaciones.vue"),
  },
  {
    path: "/CfdiIngreso",
    name: "CfdiIngreso",
    component: () => import("../pages/CfdiIngreso.vue"),
  },
  {
    path: "/ControlCasaLey",
    name: "ControlCasaLey",
    component: () => import("../pages/ControlCasaLey.vue"),
  },
  {
    path: "/excel",
    name: "excel",
    component: () => import("../components/TablaExcel.vue"),
  },
  {
    path: "/ControlAltaEmpleados/datosGenerales",
    name: "Datos Generales",
    component: () => import("../pages/ControlCasaLey.vue"),
  },
  {
    path: "/catalogos",
    name: "catalogos", // Changed from 'Catalogos' to lowercase 'catalogos'
    component: () => import("../pages/Catalogos.vue"),
  },
  {
    path: "/gestion-tiendas",
    name: "gestion-tiendas",
    component: () => import("../components/catalogs/Tiendas.vue"),
  },
  {
    path: "/catalogos-main",
    name: "catalogos-main",
    component: () => import("../pages/CatalogosMain.vue"),
  },
  {
    path: "/catalogos/bancos",
    name: "catalogos-bancos",
    component: () => import("../pages/catalogs/BancosCatalog.vue"),
  },
  {
    path: "/catalogos/areas",
    name: "catalogos-areas",
    component: () => import("../pages/catalogs/AreasCatalog.vue"),
  },
  {
    path: "/catalogos/clientes",
    name: "catalogos-clientes",
    component: () => import("../pages/catalogs/ClientesCatalog.vue"),
  },
  {
    path: "/catalogos/codigos-postales",
    name: "catalogos-codigos-postales",
    component: () => import("../pages/catalogs/CodigosPostalesCatalog.vue"),
  },
  {
    path: "/catalogos/colonias",
    name: "catalogos-colonias",
    component: () => import("../pages/catalogs/ColoniasCatalog.vue"),
  },
  {
    path: "/catalogos/departamentos",
    name: "catalogos-departamentos",
    component: () => import("../pages/catalogs/DepartamentosCatalog.vue"),
  },
  {
    path: "/catalogos/empresas",
    name: "catalogos-empresas",
    component: () => import("../pages/catalogs/EmpresasCatalog.vue"),
  },
  {
    path: "/catalogos/empleado-cuenta-bancaria",
    name: "catalogos-empleado-cuenta-bancaria",
    component: () =>
      import("../pages/catalogs/EmpleadoCuentaBancariaCatalog.vue"),
  },
  {
    path: "/catalogos/estados",
    name: "catalogos-estados",
    component: () => import("../pages/catalogs/EstadosCatalog.vue"),
  },
  {
    path: "/catalogos/esquemas",
    name: "catalogos-esquemas",
    component: () => import("../pages/catalogs/EsquemasCatalog.vue"),
  },
  {
    path: "/catalogos/municipios",
    name: "catalogos-municipios",
    component: () => import("../pages/catalogs/MunicipiosCatalog.vue"),
  },
  {
    path: "/catalogos/paises",
    name: "catalogos-paises",
    component: () => import("../pages/catalogs/PaisesCatalog.vue"),
  },
  {
    path: "/catalogos/periodos-pago",
    name: "catalogos-periodos-pago",
    component: () => import("../pages/catalogs/PeriodosPagoCatalog.vue"),
  },
  {
    path: "/catalogos/puestos",
    name: "catalogos-puestos",
    component: () => import("../pages/catalogs/PuestosCatalog.vue"),
  },
  {
    path: "/catalogos/tabuladores",
    name: "catalogos-tabuladores",
    component: () => import("../pages/catalogs/TabuladoresCatalog.vue"),
  },
  {
    path: "/catalogos/tipos-tabulador",
    name: "catalogos-tipos-tabulador",
    component: () => import("../pages/catalogs/TiposTabuladorCatalog.vue"),
  },
  {
    path: "/catalogos/tipos-tienda",
    name: "catalogos-tipos-tienda",
    component: () => import("../pages/catalogs/TiposTiendaCatalog.vue"),
  },
  {
    path: "/catalogos/tipos-zona-tabulador",
    name: "catalogos-tipos-zona-tabulador",
    component: () => import("../pages/catalogs/TiposZonaTabuladorCatalog.vue"),
  },
  {
    path: "/catalogos/proveedores",
    name: "catalogos-proveedores",
    component: () => import("../components/catalogs/Proveedores.vue"),
  },
  {
    path: "/catalogos/formatos",
    name: "catalogos-formatos",
    component: () => import("../pages/catalogs/FormatosCatalog.vue"),
  },
  {
    path: "/catalogos/proyectos",
    name: "catalogos-proyectos",
    component: () => import("../pages/catalogs/ProyectosCatalog.vue"),
  },
  {
    path: "/catalogos/marcas",
    name: "catalogos-marcas",
    component: () => import("../pages/catalogs/MarcasCatalog.vue"),
  },
  {
    path: "/catalogos/submarcas",
    name: "catalogos-submarcas",
    component: () => import("../pages/catalogs/SubmarcasCatalog.vue"),
  },
  {
    path: "/catalogos/anios",
    name: "catalogos-anios",
    component: () => import("../pages/catalogs/AniosCatalog.vue"),
  },
  {
    path: "/catalogos/colores",
    name: "catalogos-colores",
    component: () => import("../pages/catalogs/ColoresCatalog.vue"),
  },
  {
    path: "/catalogos/esquemas-unidad",
    name: "catalogos-esquemas-unidad",
    component: () => import("../pages/catalogs/EsquemasUnidadCatalog.vue"),
  },
  {
    path: "/catalogos/aseguradoras",
    name: "catalogos-aseguradoras",
    component: () => import("../pages/catalogs/AseguradorasCatalog.vue"),
  },
  {
    path: "/catalogos/tipos-vehiculo",
    name: "catalogos-tipos-vehiculo",
    component: () => import("../pages/catalogs/TiposVehiculoCatalog.vue"),
  },

  // Catálogos de Asignaciones
  {
    path: "/catalogos/roles-asignacion",
    name: "catalogos-roles-asignacion",
    component: () => import("../pages/catalogs/RolesAsignacionCatalog.vue"),
  },
  {
    path: "/catalogos/tipos-servicio-asignacion",
    name: "catalogos-tipos-servicio-asignacion",
    component: () => import("../pages/catalogs/ServiciosAsignacionCatalog.vue"),
  },
  {
    path: "/catalogos/estatus-operacion-asignacion",
    name: "catalogos-estatus-operacion-asignacion",
    component: () => import("../pages/catalogs/EstatusOperacionAsignacionCatalog.vue"),
  },
  {
    path: "/catalogos/usuario-rol",
    name: "catalogos-usuario-rol",
    component: () => import("../pages/catalogs/UsuarioRolCatalog.vue"),
  },

  {
    path: "/catalogos_Flota",
    name: "catalogos_Flota", // Cambiado de 'catalogosFlota' a 'catalogos_Flota' para que coincida con el nombre usado en el menú
    component: () => import("../pages/Catalogo_Unidades_Flota.vue"),
  },

  // Gestión de Roles y Accesos
  {
    path: "/roles/sistemas",
    name: "roles-sistemas",
    component: () => import("../components/roles/SistemasManagement.vue"),
  },
  {
    path: "/roles/roles",
    name: "roles-roles",
    component: () => import("../components/roles/RolesManagement.vue"),
  },
  {
    path: "/roles/rutas-menu",
    name: "roles-rutas-menu",
    component: () => import("../components/roles/SubaccesosManagement.vue"),
  },
  {
    path: "/roles/accesos",
    name: "roles-accesos",
    component: () => import("../components/roles/AccesosPage.vue"),
  },
  {
    path: "/roles/accesos-especiales",
    name: "AccesoEspecialCatalog",
    component: () => import("../pages/catalogs/AccesoEspecialCatalog.vue"),
  },
  {
    path: "/asignacion-empleado-tienda",
    name: "asignacion-empleado-tienda",
    component: () => import("../pages/AsignacionEmpleadoTiendaCustom.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// Middleware local: Actualizar caché de acciones de RBAC al navegar
router.beforeEach(async (to, from, next) => {
  const usuario = localStorage.getItem('usuario');
  // Si hay sesión activa (usuario presente)
  if (usuario) {
    try {
      const menuService = new MenuService();
      // Obtener tanto el menú estándar como los accesos especiales
      const [menuData, especiales] = await Promise.all([
        menuService.getMenuByUsuario(usuario),
        menuService.catalogService.getAllAccesosEspeciales(usuario)
      ]);
      
      const accionesRutaActual = new Set();

      // 1. Recolectar del menú estándar (Roles)
      if (menuData && menuData.length > 0) {
        menuData.forEach(menu => {
          (menu.subMenu || []).forEach(sub => {
            if (sub.route === to.name || '/' + sub.route === to.path) {
              (sub.acciones || []).forEach(a => accionesRutaActual.add(a));
            }
          });
        });
      }

      // 2. Recolectar de accesos especiales (Suma/Unión)
      if (especiales && especiales.length > 0) {
        especiales.forEach(esp => {
          if (esp.subaccesoRoute === to.name || '/' + esp.subaccesoRoute === to.path || 
              esp.ruta === to.name || '/' + esp.ruta === to.path) {
            (esp.accionNombres || []).forEach(a => accionesRutaActual.add(a));
          }
        });
      }

      localStorage.setItem('acciones', JSON.stringify([...accionesRutaActual]));
      
      // Notificamos a los componentes visuales para que re-evaluen la caché local
      window.dispatchEvent(new Event('rbac-acciones-updated'));

    } catch (e) {
      console.warn("Fallo al refrescar permisos de acciones de RBAC en background", e);
    }
  }
  
  // Continuar siempre con la navegación
  next();
});

export default router;
